import NavigationBar from "../components/navigationBar";
import OrderSummaryPageView from "../components/shop/order-summary/orderSummaryPageView";
import FooterView from "../components/footerView";


export default function OrderSummary() {

    return (
        <div>
            <NavigationBar />
            <OrderSummaryPageView />
            <FooterView />
        </div>
    )
}